import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { B2bScrollEndDirective } from './directives/b2b-scroll-end.directive';
import { B2bScrollEndRootDirective } from './directives/b2b-scroll-end-root.directive';

@NgModule({
    imports: [CommonModule, B2bScrollEndDirective, B2bScrollEndRootDirective],
    exports: [B2bScrollEndDirective, B2bScrollEndRootDirective],
})
export class B2bScrollLibModule {}
